import React from 'react';

const Side = () => {
  return (
    <div className='row'>
      <div className='col no-padding'>
        <div className='side'>
          <div className='phone' />
        </div>
      </div>
    </div>
  );
};

export default Side;
